const lis = document.getElementById("reviews-slider").getElementsByTagName("li");
let numSlides = lis.length;
let curPos = 0;
let step = 335;

function updateAriaHidden() {
    // lis.forEach((li, index) => {
    //     if (index === curPos) {
    //         li.removeAttribute('aria-hidden');
    //     } else {
    //         li.setAttribute('aria-hidden', 'true');
    //     }
    // });
}

function slideReviewRight() {
    curPos++;
    if(curPos >= numSlides) curPos = 0;
    if(window.innerWidth >= 1024) step = document.getElementById('reviews-slider-wrapper').offsetWidth;;

    lis.forEach(function (li, index) {
        li.style.left = (-1) * step * curPos + 'px';
    });
    updateAriaHidden();
    return true;
}

function slideReviewLeft() {
    curPos--;
    if(curPos < 0) curPos = numSlides - 1;
    if(window.innerWidth >= 1024) step = document.getElementById('reviews-slider-wrapper').offsetWidth;;

    lis.forEach(function (li, index) {
        li.style.left =  (-1) * step * curPos + 'px';
    });
    updateAriaHidden();
    return true;
}

if(window.innerWidth < 1024){
    // setInterval(slideReviewRight, 4000);
}

// Set initial aria states
document.addEventListener('DOMContentLoaded', () => {
  updateAriaHidden();
  document.getElementById("next-review").addEventListener("click", slideReviewRight);
  document.getElementById("prev-review").addEventListener("click", slideReviewLeft);
});

